module.exports = __webpack_public_path__ + "static/media/image_63.1cb8ad6e.png";